import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=52d33250&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=52d33250&prod&scoped=true&lang=css"
import style1 from "./Menu.vue?vue&type=style&index=1&id=52d33250&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d33250",
  null
  
)

export default component.exports